import React, {useContext, useEffect, useState} from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import {httpRequestWithAuth} from "../../auth/axios_instance";
import {
    BaseViewNoneCreatedByModifiedByEntityURL
} from "../../urls";
import {AlertContext} from "../../store/use_context";


export const ViewNoneCreatedByModifiedByEntity = props =>{
    const {setAlert} = useContext(AlertContext);

    const columns = [
        {title: "Model", field: 'model_name'},
        {title: "None created by", field: 'none_created_by'},
        {title: "None modified by", field: 'none_modified_by'},
        {title: "None entity by", field: 'none_entity'},
    ];

    const [data, setData] = useState([]);
    const [is_loading, setIsLoading] = useState(false);



    useEffect(()=>{
        const fetchData = async ()=>{
            await setIsLoading(true);

            let response = await httpRequestWithAuth(BaseViewNoneCreatedByModifiedByEntityURL, "GET");
            if (response.status){
                setData(response.data);
            }
            await setIsLoading(false);
        }
        fetchData();
    },[]);



    return(
        <Paper className="flex-column align-items-center d-flex Paper">
            <Grid container spacing={2} className="mt-5">
                <Grid item xs={12}>
                    <MaterialTable
                        title="None Data"
                        columns={columns}
                        data={data}
                        isLoading={is_loading}

                        style={{
                            padding: "0.5rem",
                            boxShadow: "none",
                        }}

                        options={{
                            showTitle: false,
                            searchFieldAlignment: 'left',
                            actionsColumnIndex: -1,
                            paging: false,
                        }}
                    />
                </Grid>
            </Grid>
        </Paper>
    )
}
